import React from 'react';
import { Input, Select } from '@scuf/common';

import { consumeAPIs } from '../../commonUtils/APIContext';
import ViewData from '../../commonUtils/ViewData';
import { IRoleResponse } from '../onboardingModels';
import { IOption } from '@scuf/common/dist/components/Select/ISelectProps';
import './AddUserDetails.scss';
import { checkEmailIsValid } from '../onboardingUtils';
import i18next from '../../../i18next';
import { ErrorGeneric } from '../../commonUtils/useFetch';
import { useFlags } from 'launchdarkly-react-client-sdk';

interface IAddUserDetailsProps {
  newUserEmailInput: string;
  isUserEmailExist: boolean;
  role: string;
  roleList: IRoleResponse;
  isLoadingRoleList: boolean;
  errorRoleList: ErrorGeneric | undefined;
  handleChange: (event: any, type: string) => void;
}

export const AddUserDetails = (props: IAddUserDetailsProps) => {
  const flags = useFlags();
  const isMonitorRoleEnabled = () => {    
    return flags?.enableMonitorRole ? flags.enableMonitorRole : false;
  }

  const emailError = (email: string) => {
    if (email) {
      return checkEmailIsValid(email)
        ? ''
        : i18next.t('validEmail');
    } else {
      return i18next.t('requiredEmail');
    }
  };

  return (
    <div className="new-user-modal">
      <Input
        label={i18next.t('email')}
        type="email"
        className="inputBox"
        value={props.newUserEmailInput}
        error={ props.isUserEmailExist ? i18next.t('userAlreadyExist') :
          props.newUserEmailInput ? emailError(props.newUserEmailInput) : ''
        }
        onChange={e => props.handleChange(e, 'email')}
      />
      <div className="roles-box">
        <ViewData
          isError={props.errorRoleList}
          isLoading={props.isLoadingRoleList}
          errorMessage={i18next.t('rolesError')}
          loadingMessage={i18next.t('loadingRoles')}
          contentRender={() => (
            <>
              <div>
                <b>{i18next.t('roles')}</b>
              </div>
              <Select
                placeholder={i18next.t('selectRole')}
                value={props.role}
                options={
                  props.roleList
                    ? props.roleList.resources
                    .filter(resource => !(resource.name === 'Monitor' && !isMonitorRoleEnabled()))
                    .map(resource => {
                        const newOption: IOption = {
                          text: resource.name,
                          value: resource.id
                        };
                        return newOption;
                      })
                    : []
                }
                onChange={e => props.handleChange(e, 'role')}
              />
              <br />
            </>
          )}
        />
      </div>
    </div>
  );
};

export default consumeAPIs(AddUserDetails);
